export { Button1, Button2 } from '@sberdevices/plasma-core';
